export type ContractQuantityTerms = {
  releaseMinimumBags: number;
  releaseQuantityIncrementBags: number;
};

export const NEW_CONTRACT_QUANTITY_TERMS: Readonly<ContractQuantityTerms> = {
  releaseMinimumBags: 1,
  releaseQuantityIncrementBags: 1,
};

// Contracts written before quantity terms were stored used the ten-bag policy.
// Keep that historical policy explicit instead of applying new defaults to them.
const LEGACY_CONTRACT_QUANTITY_TERMS: Readonly<ContractQuantityTerms> = {
  releaseMinimumBags: 10,
  releaseQuantityIncrementBags: 10,
};

export function getContractQuantityTerms(contract: {
  isPrepaid?: boolean;
  releaseMinimumBags?: number;
  releaseQuantityIncrementBags?: number;
}): ContractQuantityTerms {
  if (contract.isPrepaid === true) return { ...NEW_CONTRACT_QUANTITY_TERMS };
  if (
    contract.releaseMinimumBags === undefined &&
    contract.releaseQuantityIncrementBags === undefined
  )
    return { ...LEGACY_CONTRACT_QUANTITY_TERMS };
  const { releaseMinimumBags, releaseQuantityIncrementBags } = contract;
  if (
    !Number.isInteger(releaseMinimumBags) ||
    !Number.isInteger(releaseQuantityIncrementBags) ||
    releaseMinimumBags! <= 0 ||
    releaseQuantityIncrementBags! <= 0
  )
    throw new Error(
      "Contract minimum and quantity increment must be positive whole numbers.",
    );
  return {
    releaseMinimumBags: releaseMinimumBags!,
    releaseQuantityIncrementBags: releaseQuantityIncrementBags!,
  };
}
